import { useState } from "react";
import Barcode from "react-barcode";
import { QRCodeCanvas } from "qrcode.react";

// CSS
import "./BarcodeScannerComponent.css";

// Components
import Button from "./button";

// Functions and hooks
import { usePopup } from "../../Contexts/PopupContext";
import { useTranslation } from "react-i18next";

const BarcodeDisplayComponent = ({
  value,
  className = "w-100%",
  showButton = true,
  buttonText,
  barcodeSize = 150,
  qrSize = 150,
  onClick,
}) => {
  const { showPopup, removePopup } = usePopup();
  const { t } = useTranslation();

  const isLikelyBarcode = (code) => {
    return /^\d{8,13}$/.test(code);
  };

  const openCodeView = () => {
    if (!onClick && !value) return;
    let localValue = onClick ? onClick() : "";
    console.log("localValue", localValue);
    if (value) {
      localValue = value;
      console.log("localValue2", localValue);
    }
    if (!localValue) return;

    const key = Date.now();
    showPopup(
      <div className="barcode-overlay">
        <div className="barcode-scanner-container">
          <div className="code-display-container">
            {isLikelyBarcode(value) ? (
              <Barcode value={localValue} width={2} height={100} />
            ) : (
              <QRCodeCanvas value={localValue} size={qrSize} />
            )}
          </div>
          <Button
            btnStyle={"btn-secondary"}
            btnSize={"btn-small"}
            onClick={() => removePopup(key)}
            className="mt-3"
          >
            {t("Close")}
          </Button>
        </div>
      </div>,
      key
    );
  };

  const renderInlineCode = () => {
    if (!value) return null;

    return (
      <div className="inline-code-display">
        {isLikelyBarcode(value) ? (
          <Barcode value={value} width={1} height={50} />
        ) : (
          <QRCodeCanvas value={value} size={barcodeSize} />
        )}
      </div>
    );
  };

  if (!showButton) {
    return (
      <div className={"barcode-display-component " + className}>
        {renderInlineCode()}
      </div>
    );
  }

  return (
    <Button
      btnStyle="btn-secondary"
      className="mb-1"
      onClick={openCodeView}
      disabled={!value && !onClick}
    >
      {buttonText || t("Show Code")}
    </Button>
  );
};

export default BarcodeDisplayComponent;
